module.exports = __webpack_public_path__ + "img/NEWCR3.2c738bd8.svg";